import { render, staticRenderFns } from "./jy-arrive.vue?vue&type=template&id=76e52180&scoped=true&"
import script from "./jy-arrive.vue?vue&type=script&lang=js&"
export * from "./jy-arrive.vue?vue&type=script&lang=js&"
import style0 from "./jy-arrive.vue?vue&type=style&index=0&id=76e52180&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e52180",
  null
  
)

export default component.exports